import { CountryCodesOption } from "../../types/components";

export const countryCodes: CountryCodesOption[] = [
  {
    id: 87,
    code: "GR",
    name: "Ελλάδα",
    prefix: "30",
  },
  {
    id: 53,
    code: "CY",
    name: "Κύπρος",
    prefix: "357",
  },
  {
    id: 232,
    code: "VC",
    name: "Άγιος Βικέντιος",
    prefix: "1784",
  },
  {
    id: 201,
    code: "SM",
    name: "Άγιος Μαρίνος",
    prefix: "378",
  },
  {
    id: 177,
    code: "PM",
    name: "Άγιος Πέτρος και Μικελόν",
    prefix: "508",
  },
  {
    id: 118,
    code: "KN",
    name: "Άγιος Χριστόφορος και Νέβις",
    prefix: "1869",
  },
  {
    id: 17,
    code: "AZ",
    name: "Αζερμπαϊτζάν",
    prefix: "994",
  },
  {
    id: 63,
    code: "EG",
    name: "Αίγυπτος",
    prefix: "20",
  },
  {
    id: 67,
    code: "ET",
    name: "Αιθιοπία",
    prefix: "251",
  },
  {
    id: 97,
    code: "HT",
    name: "Αϊτή",
    prefix: "509",
  },
  {
    id: 43,
    code: "CI",
    name: "Ακτή Ελεφαντοστού",
    prefix: "225",
  },
  {
    id: 6,
    code: "AL",
    name: "Αλβανία",
    prefix: "355",
  },
  {
    id: 60,
    code: "DZ",
    name: "Αλγερία",
    prefix: "213",
  },
  {
    id: 12,
    code: "AS",
    name: "Αμερικανική Σαμόα",
    prefix: "1684",
  },
  {
    id: 216,
    code: "TL",
    name: "Ανατολικό Τιμόρ",
    prefix: "670",
  },
  {
    id: 9,
    code: "AO",
    name: "Ανγκόλα",
    prefix: "244",
  },
  {
    id: 5,
    code: "AI",
    name: "Ανγκουίλα",
    prefix: "1264",
  },
  {
    id: 1,
    code: "AD",
    name: "Ανδόρρα",
    prefix: "376",
  },
  {
    id: 10,
    code: "AQ",
    name: "Ανταρκτική",
    prefix: "672",
  },
  {
    id: 4,
    code: "AG",
    name: "Αντίγκουα και Μπαρμπούντα",
    prefix: "1268",
  },
  {
    id: 11,
    code: "AR",
    name: "Αργεντινή",
    prefix: "54",
  },
  {
    id: 7,
    code: "AM",
    name: "Αρμενία",
    prefix: "374",
  },
  {
    id: 15,
    code: "AW",
    name: "Αρούμπα",
    prefix: "297",
  },
  {
    id: 14,
    code: "AU",
    name: "Αυστραλία",
    prefix: "61",
  },
  {
    id: 13,
    code: "AT",
    name: "Αυστρία",
    prefix: "43",
  },
  {
    id: 3,
    code: "AF",
    name: "Αφγανιστάν",
    prefix: "93",
  },
  {
    id: 237,
    code: "VU",
    name: "Βανουάτου",
    prefix: "678",
  },
  {
    id: 231,
    code: "VA",
    name: "Βατικανό",
    prefix: "39",
  },
  {
    id: 21,
    code: "BE",
    name: "Βέλγιο",
    prefix: "32",
  },
  {
    id: 233,
    code: "VE",
    name: "Βενεζουέλα",
    prefix: "58",
  },
  {
    id: 27,
    code: "BM",
    name: "Βερμούδες",
    prefix: "1441",
  },
  {
    id: 236,
    code: "VN",
    name: "Βιετνάμ",
    prefix: "84",
  },
  {
    id: 143,
    code: "MM",
    name: "Βιρμανία",
    prefix: "95",
  },
  {
    id: 29,
    code: "BO",
    name: "Βολιβία",
    prefix: "591",
  },
  {
    id: 119,
    code: "KP",
    name: "Βόρεια Κορέα",
    prefix: "850",
  },
  {
    id: 146,
    code: "MP",
    name: "Βόρειες Μαριάνες Νήσοι",
    prefix: "1670",
  },
  {
    id: 18,
    code: "BA",
    name: "Βοσνία-Ερζεγοβίνη",
    prefix: "387",
  },
  {
    id: 23,
    code: "BG",
    name: "Βουλγαρία",
    prefix: "359",
  },
  {
    id: 30,
    code: "BR",
    name: "Βραζιλία",
    prefix: "55",
  },
  // {
  //   id: 104,
  //   code: "IO",
  //   name: "Βρετανικά Εδάφη Ινδικού Ωκεανού",
  //   prefix: "",
  // },
  {
    id: 234,
    code: "VG",
    name: "Βρετανικές Παρθένοι Νήσοι",
    prefix: "1284",
  },
  {
    id: 73,
    code: "FR",
    name: "Γαλλία",
    prefix: "33",
  },
  // {
  //   id: 211,
  //   code: "TF",
  //   name: "Γαλλικά νότια και ανταρκτικά εδάφη",
  //   prefix: "",
  // },
  // {
  //   id: 78,
  //   code: "GF",
  //   name: "Γαλλική Γουιάνα",
  //   prefix: "",
  // },
  {
    id: 172,
    code: "PF",
    name: "Γαλλική Πολυνησία",
    prefix: "689",
  },
  {
    id: 55,
    code: "DE",
    name: "Γερμανία",
    prefix: "49",
  },
  {
    id: 77,
    code: "GE",
    name: "Γεωργία",
    prefix: "995",
  },
  {
    id: 81,
    code: "GI",
    name: "Γιβραλτάρ",
    prefix: "350",
  },
  {
    id: 83,
    code: "GM",
    name: "Γκάμπια",
    prefix: "220",
  },
  {
    id: 74,
    code: "GA",
    name: "Γκαμπόν",
    prefix: "241",
  },
  {
    id: 80,
    code: "GH",
    name: "Γκάνα",
    prefix: "233",
  },
  // {
  //   id: 79,
  //   code: "GG",
  //   name: "Γκέρνσεϋ",
  //   prefix: "",
  // },
  {
    id: 90,
    code: "GU",
    name: "Γκουάμ",
    prefix: "1671",
  },
  {
    id: 85,
    code: "GP",
    name: "Γουαδελούπη",
    prefix: "502",
  },
  {
    id: 89,
    code: "GT",
    name: "Γουατεμάλα",
    prefix: "502",
  },
  {
    id: 92,
    code: "GY",
    name: "Γουιάνα",
    prefix: "592",
  },
  {
    id: 84,
    code: "GN",
    name: "Γουινέα",
    prefix: "224",
  },
  {
    id: 91,
    code: "GW",
    name: "Γουινέα-Μπισσάου",
    prefix: "245",
  },
  {
    id: 76,
    code: "GD",
    name: "Γρενάδα",
    prefix: "1473",
  },
  {
    id: 82,
    code: "GL",
    name: "Γροιλανδία",
    prefix: "299",
  },
  {
    id: 57,
    code: "DK",
    name: "Δανία",
    prefix: "45",
  },
  {
    id: 40,
    code: "CF",
    name: "Δημοκρατία Κεντρικής Αφρικής",
    prefix: "236",
  },
  {
    id: 59,
    code: "DO",
    name: "Δομινικανή Δημοκρατία",
    prefix: "1809",
  },
  // {
  //   id: 180,
  //   code: "PS",
  //   name: "Δυτική Όχθη",
  //   prefix: "",
  // },
  // {
  //   id: 64,
  //   code: "EH",
  //   name: "Δυτική Σαχάρα",
  //   prefix: "",
  // },
  {
    id: 206,
    code: "SV",
    name: "Ελ Σαλβαδόρ",
    prefix: "503",
  },
  {
    id: 42,
    code: "CH",
    name: "Ελβετία",
    prefix: "41",
  },
  {
    id: 65,
    code: "ER",
    name: "Ερυθραία",
    prefix: "291",
  },
  {
    id: 62,
    code: "EE",
    name: "Εσθονία",
    prefix: "372",
  },
  {
    id: 243,
    code: "ZM",
    name: "Ζάμπια",
    prefix: "260",
  },
  {
    id: 244,
    code: "ZW",
    name: "Ζιμπάμπουε",
    prefix: "263",
  },
  {
    id: 2,
    code: "AE",
    name: "Ηνωμένα Αραβικά Εμιράτα",
    prefix: "971",
  },
  {
    id: 228,
    code: "US",
    name: "Ηνωμένες Πολιτείες",
    prefix: "1",
  },
  // {
  //   id: 227,
  //   code: "UM",
  //   name: "Ηνωμένες Πολιτείες - Μικρά απομακρυσμένα νησιά",
  //   prefix: "",
  // },
  {
    id: 75,
    code: "GB",
    name: "Ηνωμένο Βασίλειο",
    prefix: "44",
  },
  {
    id: 112,
    code: "JP",
    name: "Ιαπωνία",
    prefix: "81",
  },
  {
    id: 103,
    code: "IN",
    name: "Ινδία",
    prefix: "91",
  },
  {
    id: 99,
    code: "ID",
    name: "Ινδονησία",
    prefix: "62",
  },
  {
    id: 111,
    code: "JO",
    name: "Ιορδανία",
    prefix: "962",
  },
  {
    id: 105,
    code: "IQ",
    name: "Ιράκ",
    prefix: "964",
  },
  {
    id: 106,
    code: "IR",
    name: "Ιράν",
    prefix: "98",
  },
  {
    id: 100,
    code: "IE",
    name: "Ιρλανδία",
    prefix: "353",
  },
  {
    id: 86,
    code: "GQ",
    name: "Ισημερινή Γουινέα",
    prefix: "240",
  },
  {
    id: 61,
    code: "EC",
    name: "Ισημερινός",
    prefix: "593",
  },
  {
    id: 107,
    code: "IS",
    name: "Ισλανδία",
    prefix: "354",
  },
  {
    id: 66,
    code: "ES",
    name: "Ισπανία",
    prefix: "34",
  },
  {
    id: 101,
    code: "IL",
    name: "Ισραήλ",
    prefix: "972",
  },
  {
    id: 108,
    code: "IT",
    name: "Ιταλία",
    prefix: "39",
  },
  {
    id: 123,
    code: "KZ",
    name: "Καζακστάν",
    prefix: "7",
  },
  {
    id: 46,
    code: "CM",
    name: "Καμερούν",
    prefix: "237",
  },
  {
    id: 115,
    code: "KH",
    name: "Καμπότζη",
    prefix: "855",
  },
  {
    id: 37,
    code: "CA",
    name: "Καναδάς",
    prefix: "1",
  },
  {
    id: 184,
    code: "QA",
    name: "Κατάρ",
    prefix: "974",
  },
  {
    id: 163,
    code: "NL",
    name: "Κάτω Χώρες",
    prefix: "31",
  },
  {
    id: 113,
    code: "KE",
    name: "Κένυα",
    prefix: "254",
  },
  {
    id: 47,
    code: "CN",
    name: "Κίνα",
    prefix: "86",
  },
  {
    id: 114,
    code: "KG",
    name: "Κιργιζιστάν",
    prefix: "996",
  },
  {
    id: 116,
    code: "KI",
    name: "Κιριμπάτι",
    prefix: "686",
  },
  {
    id: 41,
    code: "CG",
    name: "Κογκό",
    prefix: "242",
  },
  {
    id: 48,
    code: "CO",
    name: "Κολομβία",
    prefix: "57",
  },
  {
    id: 117,
    code: "KM",
    name: "Κομόρες",
    prefix: "269",
  },
  {
    id: 49,
    code: "CR",
    name: "Κόστα Ρίκα",
    prefix: "506",
  },
  {
    id: 50,
    code: "CU",
    name: "Κούβα",
    prefix: "53",
  },
  {
    id: 121,
    code: "KW",
    name: "Κουβέιτ",
    prefix: "965",
  },
  {
    id: 96,
    code: "HR",
    name: "Κροατία",
    prefix: "385",
  },
  {
    id: 39,
    code: "CD",
    name: "Λαϊκή Δημοκρατία του Κογκό",
    prefix: "243",
  },
  {
    id: 124,
    code: "LA",
    name: "Λάος",
    prefix: "856",
  },
  {
    id: 130,
    code: "LS",
    name: "Λεσότο",
    prefix: "266",
  },
  {
    id: 133,
    code: "LV",
    name: "Λετονία",
    prefix: "371",
  },
  {
    id: 35,
    code: "BY",
    name: "Λευκορωσία",
    prefix: "375",
  },
  {
    id: 125,
    code: "LB",
    name: "Λίβανος",
    prefix: "961",
  },
  {
    id: 129,
    code: "LR",
    name: "Λιβερία",
    prefix: "231",
  },
  {
    id: 134,
    code: "LY",
    name: "Λιβύη",
    prefix: "218",
  },
  {
    id: 131,
    code: "LT",
    name: "Λιθουανία",
    prefix: "370",
  },
  {
    id: 127,
    code: "LI",
    name: "Λιχτενστάιν",
    prefix: "423",
  },
  {
    id: 132,
    code: "LU",
    name: "Λουξεμβούργο",
    prefix: "352",
  },
  {
    id: 241,
    code: "YT",
    name: "Μαγιότ",
    prefix: "269",
  },
  {
    id: 139,
    code: "MG",
    name: "Μαδαγασκάρη",
    prefix: "261",
  },
  {
    id: 145,
    code: "MO",
    name: "Μακάο",
    prefix: "853",
  },
  {
    id: 155,
    code: "MY",
    name: "Μαλαισία",
    prefix: "60",
  },
  {
    id: 153,
    code: "MW",
    name: "Μαλάουι",
    prefix: "265",
  },
  {
    id: 152,
    code: "MV",
    name: "Μαλδίβες",
    prefix: "960",
  },
  {
    id: 142,
    code: "ML",
    name: "Μαλί",
    prefix: "223",
  },
  {
    id: 150,
    code: "MT",
    name: "Μάλτα",
    prefix: "356",
  },
  {
    id: 135,
    code: "MA",
    name: "Μαρόκο",
    prefix: "212",
  },
  // {
  //   id: 147,
  //   code: "MQ",
  //   name: "Μαρτινίκα",
  //   prefix: "",
  // },
  {
    id: 151,
    code: "MU",
    name: "Μαυρίκιος",
    prefix: "230",
  },
  {
    id: 148,
    code: "MR",
    name: "Μαυριτανία",
    prefix: "222",
  },
  {
    id: 138,
    code: "ME",
    name: "Μαυροβούνιο",
    prefix: "382",
  },
  {
    id: 154,
    code: "MX",
    name: "Μεξικό",
    prefix: "52",
  },
  {
    id: 144,
    code: "MN",
    name: "Μογγολία",
    prefix: "976",
  },
  {
    id: 156,
    code: "MZ",
    name: "Μοζαμβίκη",
    prefix: "258",
  },
  {
    id: 137,
    code: "MD",
    name: "Μολδαβία",
    prefix: "373",
  },
  {
    id: 136,
    code: "MC",
    name: "Μονακό",
    prefix: "377",
  },
  {
    id: 149,
    code: "MS",
    name: "Μοντσερράτ",
    prefix: "1664",
  },
  {
    id: 20,
    code: "BD",
    name: "Μπαγκλαντές",
    prefix: "880",
  },
  {
    id: 19,
    code: "BB",
    name: "Μπαρμπάντος",
    prefix: "1246",
  },
  {
    id: 31,
    code: "BS",
    name: "Μπαχάμες",
    prefix: "1242",
  },
  {
    id: 24,
    code: "BH",
    name: "Μπαχρέιν",
    prefix: "973",
  },
  {
    id: 36,
    code: "BZ",
    name: "Μπελίζ",
    prefix: "501",
  },
  {
    id: 26,
    code: "BJ",
    name: "Μπενίν",
    prefix: "229",
  },
  {
    id: 34,
    code: "BW",
    name: "Μποτσουάνα",
    prefix: "267",
  },
  {
    id: 22,
    code: "BF",
    name: "Μπουρκίνα Φάσο",
    prefix: "226",
  },
  {
    id: 25,
    code: "BI",
    name: "Μπουρούντι",
    prefix: "257",
  },
  {
    id: 32,
    code: "BT",
    name: "Μπουτάν",
    prefix: "975",
  },
  {
    id: 28,
    code: "BN",
    name: "Μπρουνέι",
    prefix: "673",
  },
  {
    id: 157,
    code: "NA",
    name: "Ναμίμπια",
    prefix: "264",
  },
  {
    id: 166,
    code: "NR",
    name: "Ναουρού",
    prefix: "674",
  },
  {
    id: 168,
    code: "NZ",
    name: "Νέα Ζηλανδία",
    prefix: "64",
  },
  {
    id: 158,
    code: "NC",
    name: "Νέα Καληδονία",
    prefix: "687",
  },
  {
    id: 165,
    code: "NP",
    name: "Νεπάλ",
    prefix: "977",
  },
  // {
  //   id: 33,
  //   code: "BV",
  //   name: "Νησί Μπουβέτ",
  //   prefix: "",
  // },
  // {
  //   id: 160,
  //   code: "NF",
  //   name: "Νησί Νόρφολκ",
  //   prefix: "",
  // },
  {
    id: 52,
    code: "CX",
    name: "Νησί των Χριστουγέννων",
    prefix: "61",
  },
  {
    id: 16,
    code: "AX",
    name: "Νησιά Άλαντ",
    prefix: "358",
  },
  {
    id: 38,
    code: "CC",
    name: "Νησιά Κόκος (Keeling)",
    prefix: "61",
  },
  {
    id: 140,
    code: "MH",
    name: "Νησιά Μάρσαλ",
    prefix: "692",
  },
  {
    id: 178,
    code: "PN",
    name: "Νησιά Πίτκερν",
    prefix: "64",
  },
  {
    id: 122,
    code: "KY",
    name: "Νήσοι Καίυμαν",
    prefix: "1345",
  },
  {
    id: 44,
    code: "CK",
    name: "Νήσοι Κουκ",
    prefix: "682",
  },
  {
    id: 191,
    code: "SB",
    name: "Νήσοι του Σολομώντος",
    prefix: "677",
  },
  {
    id: 72,
    code: "FO",
    name: "Νήσοι Φερόες",
    prefix: "298",
  },
  {
    id: 70,
    code: "FK",
    name: "Νήσοι Φώκλαντ",
    prefix: "500",
  },
  // {
  //   id: 94,
  //   code: "HM",
  //   name: "Νήσος Χέρντ και Νησιά ΜακΝτόναλντ",
  //   prefix: "",
  // },
  {
    id: 159,
    code: "NE",
    name: "Νίγηρας",
    prefix: "227",
  },
  {
    id: 161,
    code: "NG",
    name: "Νιγηρία",
    prefix: "234",
  },
  {
    id: 162,
    code: "NI",
    name: "Νικαράγουα",
    prefix: "505",
  },
  {
    id: 167,
    code: "NU",
    name: "Νιούε",
    prefix: "683",
  },
  {
    id: 164,
    code: "NO",
    name: "Νορβηγία",
    prefix: "47",
  },
  {
    id: 242,
    code: "ZA",
    name: "Νότια Αφρική",
    prefix: "27",
  },
  // {
  //   id: 88,
  //   code: "GS",
  //   name: "Νότια Γεωργία και Νότια Νησιά Σάντουιτς",
  //   prefix: "",
  // },
  {
    id: 120,
    code: "KR",
    name: "Νότια Κορέα",
    prefix: "82",
  },
  {
    id: 58,
    code: "DM",
    name: "Ντομίνικα",
    prefix: "1767",
  },
  {
    id: 8,
    code: "AN",
    name: "Ολλανδικές Αντίλλες",
    prefix: "599",
  },
  {
    id: 169,
    code: "OM",
    name: "Ομάν",
    prefix: "968",
  },
  {
    id: 71,
    code: "FM",
    name: "Ομόσπονδα Κράτη της Μικρονησίας",
    prefix: "691",
  },
  {
    id: 95,
    code: "HN",
    name: "Ονδούρα",
    prefix: "504",
  },
  {
    id: 238,
    code: "WF",
    name: "Ουάλις και Φουτούνα",
    prefix: "681",
  },
  {
    id: 98,
    code: "HU",
    name: "Ουγγαρία",
    prefix: "36",
  },
  {
    id: 226,
    code: "UG",
    name: "Ουγκάντα",
    prefix: "256",
  },
  {
    id: 230,
    code: "UZ",
    name: "Ουζμπεκιστάν",
    prefix: "998",
  },
  {
    id: 225,
    code: "UA",
    name: "Ουκρανία",
    prefix: "380",
  },
  {
    id: 229,
    code: "UY",
    name: "Ουρουγουάη",
    prefix: "598",
  },
  {
    id: 175,
    code: "PK",
    name: "Πακιστάν",
    prefix: "92",
  },
  {
    id: 182,
    code: "PW",
    name: "Παλάου",
    prefix: "680",
  },
  {
    id: 170,
    code: "PA",
    name: "Παναμάς",
    prefix: "507",
  },
  {
    id: 173,
    code: "PG",
    name: "Παπούα - Νέα Γουϊνέα",
    prefix: "675",
  },
  {
    id: 183,
    code: "PY",
    name: "Παραγουάη",
    prefix: "595",
  },
  {
    id: 235,
    code: "VI",
    name: "Παρθένα Νησιά",
    prefix: "1340",
  },
  {
    id: 141,
    code: "MK",
    name: "ΠΓΔΜ",
    prefix: "389",
  },
  {
    id: 171,
    code: "PE",
    name: "Περού",
    prefix: "51",
  },
  {
    id: 176,
    code: "PL",
    name: "Πολωνία",
    prefix: "48",
  },
  {
    id: 181,
    code: "PT",
    name: "Πορτογαλία",
    prefix: "351",
  },
  {
    id: 179,
    code: "PR",
    name: "Πουέρτο Ρίκο",
    prefix: "1",
  },
  {
    id: 51,
    code: "CV",
    name: "Πράσινο Ακρωτήρι",
    prefix: "238",
  },
  // {
  //   id: 185,
  //   code: "RE",
  //   name: "Ρεϋνιόν",
  //   prefix: "",
  // },
  {
    id: 189,
    code: "RW",
    name: "Ρουάντα",
    prefix: "250",
  },
  {
    id: 186,
    code: "RO",
    name: "Ρουμανία",
    prefix: "40",
  },
  {
    id: 188,
    code: "RU",
    name: "Ρωσία",
    prefix: "7",
  },
  {
    id: 239,
    code: "WS",
    name: "Σαμόα",
    prefix: "685",
  },
  {
    id: 196,
    code: "SH",
    name: "Σάντα Έλενα",
    prefix: "290",
  },
  {
    id: 126,
    code: "LC",
    name: "Σάντα Λουτσία",
    prefix: "1758",
  },
  {
    id: 205,
    code: "ST",
    name: "Σάο Τομέ και Πρίντσιπε",
    prefix: "239",
  },
  {
    id: 190,
    code: "SA",
    name: "Σαουδική Αραβία",
    prefix: "966",
  },
  // {
  //   id: 198,
  //   code: "SJ",
  //   name: "Σβάλμπαρντ",
  //   prefix: "",
  // },
  {
    id: 202,
    code: "SN",
    name: "Σενεγάλη",
    prefix: "221",
  },
  {
    id: 187,
    code: "RS",
    name: "Σερβία",
    prefix: "381",
  },
  {
    id: 192,
    code: "SC",
    name: "Σεϋχέλλες",
    prefix: "248",
  },
  {
    id: 200,
    code: "SL",
    name: "Σιέρα Λεόνε",
    prefix: "232",
  },
  {
    id: 195,
    code: "SG",
    name: "Σινγκαπούρη",
    prefix: "65",
  },
  {
    id: 199,
    code: "SK",
    name: "Σλοβακία",
    prefix: "421",
  },
  {
    id: 197,
    code: "SI",
    name: "Σλοβενία",
    prefix: "386",
  },
  {
    id: 203,
    code: "SO",
    name: "Σομαλία",
    prefix: "252",
  },
  {
    id: 208,
    code: "SZ",
    name: "Σουαζηλάνδη",
    prefix: "268",
  },
  {
    id: 193,
    code: "SD",
    name: "Σουδάν",
    prefix: "249",
  },
  {
    id: 194,
    code: "SE",
    name: "Σουηδία",
    prefix: "46",
  },
  {
    id: 204,
    code: "SR",
    name: "Σουρινάμ",
    prefix: "597",
  },
  {
    id: 128,
    code: "LK",
    name: "Σρι Λάνκα",
    prefix: "94",
  },
  {
    id: 207,
    code: "SY",
    name: "Συρία",
    prefix: "963",
  },
  {
    id: 223,
    code: "TW",
    name: "Ταϊβάν",
    prefix: "886",
  },
  {
    id: 213,
    code: "TH",
    name: "Ταϊλάνδη",
    prefix: "66",
  },
  {
    id: 224,
    code: "TZ",
    name: "Τανζανία",
    prefix: "255",
  },
  {
    id: 214,
    code: "TJ",
    name: "Τατζικιστάν",
    prefix: "992",
  },
  {
    id: 110,
    code: "JM",
    name: "Τζαμάικα",
    prefix: "1876",
  },
  // {
  //   id: 109,
  //   code: "JE",
  //   name: "Τζέρσεϋ",
  //   prefix: "",
  // },
  {
    id: 56,
    code: "DJ",
    name: "Τζιμπουτί",
    prefix: "253",
  },
  {
    id: 219,
    code: "TO",
    name: "Τόγκα",
    prefix: "676",
  },
  {
    id: 212,
    code: "TG",
    name: "Τόγκο",
    prefix: "228",
  },
  {
    id: 215,
    code: "TK",
    name: "Τοκελάου",
    prefix: "690",
  },
  {
    id: 222,
    code: "TV",
    name: "Τουβαλού",
    prefix: "688",
  },
  {
    id: 220,
    code: "TR",
    name: "Τουρκία",
    prefix: "90",
  },
  {
    id: 217,
    code: "TM",
    name: "Τουρκμενιστάν",
    prefix: "993",
  },
  {
    id: 209,
    code: "TC",
    name: "Τουρκς και Κάϊκος Νήσοι",
    prefix: "1649",
  },
  {
    id: 221,
    code: "TT",
    name: "Τρινιντάντ και Τομπάγκο",
    prefix: "1868",
  },
  {
    id: 210,
    code: "TD",
    name: "Τσαντ",
    prefix: "235",
  },
  {
    id: 54,
    code: "CZ",
    name: "Τσεχία",
    prefix: "420",
  },
  {
    id: 218,
    code: "TN",
    name: "Τυνησία",
    prefix: "216",
  },
  {
    id: 240,
    code: "YE",
    name: "Υεμένη",
    prefix: "967",
  },
  {
    id: 174,
    code: "PH",
    name: "Φιλιππίνες",
    prefix: "63",
  },
  {
    id: 68,
    code: "FI",
    name: "Φινλανδία",
    prefix: "358",
  },
  {
    id: 69,
    code: "FJ",
    name: "Φίτζι",
    prefix: "679",
  },
  {
    id: 45,
    code: "CL",
    name: "Χιλή",
    prefix: "56",
  },
  {
    id: 93,
    code: "HK",
    name: "Χονγκ Κονγκ",
    prefix: "852",
  },
];

